module.exports = {"130972400":"高新乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130972.json
// module id = 226
// module chunks = 0